export class UpdateBrandModel {
    success : boolean;
    statusCode:number;
    result: any;
    organizationName: string = "";
    logoPath: string = "";
    bannerPath: string = "";
    notebookDisclaimer: string = "";
} 